<template>
  <div class="form-group relative">
    <div class="overlay-disable-edit" v-if="isDisableEditPresentation"></div>

    <div class="setting-block qna-block">
      <label class="label-option">
        {{ $i18nPresenter.t('When can the audience send you questions?') }}
      </label>
      <div class="block-body relative" style="margin-left: 16px;">
        <div
          class="absolute top-0 left-0 w-full h-full z-10 cursor-pointer"
          v-if="planBenefit.interactivePresentation
            && !planBenefit.interactivePresentation.QnAonAllSlides"
          @click="handleCheckNeedUpgradePlan()"
        ></div>
        <div class="item-qna">
          <input
            type="radio"
            id="customCheckboxqna-slide"
            name="customCheckboxqna-slide"
            value="true"
            v-model="presentation.qnaAllSlide"
            @change="changeSettingPresentation(1)"
            :disabled="!planBenefit.interactivePresentation.QnAonAllSlides"
          />
          <label for="customCheckboxqna-slide">
            {{ $i18nPresenter.t('On all slides') }}
            <IconNeedUpgradePlan
              v-if="planBenefit.interactivePresentation"
              ref="iconNeedUpgradePlanComponentQnA"
              :noPermission="planBenefit.interactivePresentation &&
                !planBenefit.interactivePresentation.QnAonAllSlides"
              :defaultTooltip="$i18nPresenter.t(
                'Audience can send questions regardless of the slide you are presenting.'
              )"
              left="-100px"
              :upgradePlan="planBenefit.interactivePresentation.QnAonAllSlides_planName"
              featureName="QnA on all slides"
            />
          </label>
        </div>
        <div class="item-qna">
          <input
            type="radio"
            id="customCheckboxqna1-slide"
            name="customCheckboxqna1-slide"
            value="false"
            v-model="presentation.qnaAllSlide"
            @change="changeSettingPresentation(1)"
          />
          <label for="customCheckboxqna1-slide">{{ $i18nPresenter.t('Only on Q&A slides') }}</label>
        </div>
      </div>

      <!-- 17. Filter profanity -->
      <div class="block-content">
        <div class="form-check form-check-inline" v-if="profanityFilterVisible">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="check-profanity-filter"
              :disabled="isDisableWhenNotOwner"
              v-model="presentation.filteringProfanity"
              @change="changeSettingPresentation(4)"
            />
            <label
              class="custom-control-label"
              for="check-profanity-filter"
            >{{ $i18nPresenter.t('Filter profanity') }}</label>
            <span class="pl-1 title-table-presentation-tooltip">
              <b-button
                v-tooltip="$i18nPresenter.t('Hide swear words by the audience (in their submissions and nicknames)')"
                class="tooltip-btn"
              />
              <i class="fas fa-question-circle" />
            </span>
          </div>
        </div>
      </div>

      <!-- QnA Moderation -->
      <QnAModerationCheckBox />

      <div class="block-content">
        <div class="form-check form-check-inline">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="check-hide-qnaAudienceShowAll-slide"
              v-model="presentation.qnaAudienceShowAll"
              @change="changeSettingPresentation(2)"
            />
            <label class="custom-control-label" for="check-hide-qnaAudienceShowAll-slide">
              {{ $i18nPresenter.t("Allow audience to see each other's questions") }}
            </label>
            <span class="pl-1 title-table-presentation-tooltip">
              <b-button
                v-tooltip="allowAudienceSeeEachOtherTooltip"
                class="tooltip-btn"
              />
              <i class="fas fa-question-circle" />
            </span>
          </div>
        </div>
      </div>

      <div class="block-content">
        <div class="form-check form-check-inline">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="check-hide-qnaAnonymous-slide"
              v-model="presentation.qnaAnonymous"
              @change="changeSettingPresentation(3)"
            />
            <label
              class="custom-control-label"
              for="check-hide-qnaAnonymous-slide"
            >{{ $i18nPresenter.t('Allow anonymous questions') }}</label>
            <span class="pl-1 title-table-presentation-tooltip">
              <b-button
                v-tooltip="$i18nPresenter.t('Allow your audience to submit questions without providing their names')"
                class="tooltip-btn"
              />
              <i class="fas fa-question-circle" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
import QnAModerationCheckBox from '@/components/presentations/QnAModerationCheckBox.vue'
import QnAModerationCheckBoxContainer from '@/containers/qna-moderation/QnAModerationCheckBox'
import Socket from '@/socket'
import utils from '@/util'
import PresentationApi from '@/api/presentation'
import IconNeedUpgradePlan from '@/components-v2/my-plan/IconNeedUpgradePlan.vue'

export default {
  components: {
    QnAModerationCheckBox: QnAModerationCheckBoxContainer(QnAModerationCheckBox),
    IconNeedUpgradePlan,
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      planBenefit: (state) => state.planBenefit,
    }),
    ...mapGetters(['isDisableWhenNotOwner']),
    profanityFilterVisible() {
      const slideTypes = ['openEnded', 'wordCloud', 'question', 'pickAnswer', 'leaderboard', 'ideas']
      return slideTypes.includes(this.slideActive.type)
    },
    allowAudienceSeeEachOtherTooltip() {
      return this.$i18nPresenter.t('Allow the audience to see all questions on their smartphones and vote for what they want to be answered most')
    },
  },
  methods: {
    changeSettingPresentation(type) {
      const payload = {
        socketId: Socket.getSocketId(),
      }
      let text = ''
      if (type == 1) {
        payload.qnaAllSlide = this.presentation.qnaAllSlide
        text = 'Q&A on all slides'
        if (payload.qnaAllSlide == 'false') {
          text = 'Q&A only on Q&A slides'
        }
        utils.mixpanelTracking('Question And Answer', 'Q&A settings', text)
      } else if (type == 2) {
        payload.qnaAudienceShowAll = this.presentation.qnaAudienceShowAll
        text = "Checked allow audience to see each other's questions"
        if (!payload.qnaAudienceShowAll) {
          text = "Unchecked allow audience to see each other's questions"
        }
        utils.mixpanelTracking('Question And Answer', 'Q&A settings', text)
      } else if (type == 3) {
        payload.qnaAnonymous = this.presentation.qnaAnonymous
        text = 'Checked allow anonymous questions'
        if (!payload.qnaAnonymous) {
          text = 'Uncheck allow anonymous questions'
        }
        utils.mixpanelTracking('Question And Answer', 'Q&A settings', text)
      } else if (type == 4) {
        payload.filteringProfanity = this.presentation.filteringProfanity
      }
      this._updatePresentation(payload)
    },

    async _updatePresentation(payload) {
      try {
        await PresentationApi.updatePresentationByPresentationId(this.presentation.id, payload)
      } catch (error) {
        Sentry.captureException(error)
      }
    },
    handleCheckNeedUpgradePlan() {
      if (this.planBenefit.interactivePresentation &&
        !this.planBenefit.interactivePresentation.QnAonAllSlides) {
        this.$refs.iconNeedUpgradePlanComponentQnA.toggleTooltip()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.qna-block {
  .block-content {
    margin-bottom: 16px;
    .form-check-inline {
      cursor: pointer;

      input,
      label {
        cursor: pointer;
      }
    }
  }

  .block-body {
    margin-bottom: 8px !important;
  }
}
.item-qna {
  cursor: pointer;

  label {
    cursor: pointer;
  }

  input {
    margin-right: 4px;
    position: relative;
    top: -1px;
    cursor: pointer;
  }
}

.overlay-disable-edit {
  @apply bg-base-0 opacity-50 absolute left-0 top-0 w-full h-full;
  z-index: 9;
}
</style>
